import React, { useState } from "react";
import "./ContactOptions.css";

const ContactOptions: React.FC = () => {
  const [notification, setNotification] = useState<string | null>(null);

  const copyToClipboard = async (text: string): Promise<boolean> => {
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(text);
        return true;
      } else {
        // Fallback for older browsers or non-secure contexts
        const textArea = document.createElement("textarea");
        textArea.value = text;
        textArea.style.position = "fixed";
        textArea.style.left = "-999999px";
        textArea.style.top = "-999999px";
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        const success = document.execCommand("copy");
        document.body.removeChild(textArea);
        return success;
      }
    } catch (err) {
      console.error("Failed to copy to clipboard:", err);
      return false;
    }
  };

  const showNotification = (message: string) => {
    setNotification(message);
    setTimeout(() => setNotification(null), 3000);
  };

  const handleEmailClick = async (email: string) => {
    // Try to open mailto link first
    const mailtoWindow = window.open(`mailto:${email}`, "_blank");

    // Check if the mailto link opened successfully
    // This is a heuristic - if the window is immediately closed or null,
    // it likely means no email client is available
    setTimeout(async () => {
      if (!mailtoWindow || mailtoWindow.closed) {
        // Email client not available, try fallback options
        const copied = await copyToClipboard(email);

        if (copied) {
          showNotification(`Email copiado: ${email}`);
        } else {
          // If clipboard also fails, open Gmail in new tab as last resort
          const gmailUrl = `https://mail.google.com/mail/?view=cm&to=${encodeURIComponent(
            email
          )}`;
          window.open(gmailUrl, "_blank");
          showNotification("Abrindo Gmail em nova aba");
        }
      }
    }, 100);
  };

  const handleLinkClick = (url: string) => {
    window.open(url, "_blank");
  };

  const EmailIcon = () => (
    <svg
      className="contact-icon"
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
      <polyline points="22,6 12,13 2,6"></polyline>
    </svg>
  );

  const InstagramIcon = () => (
    <svg
      className="contact-icon"
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
      <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
      <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
    </svg>
  );

  const YouTubeIcon = () => (
    <svg
      className="contact-icon"
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z"></path>
      <polygon points="9.75,15.02 15.5,11.75 9.75,8.48"></polygon>
    </svg>
  );

  return (
    <div className="contact-options">
      <button
        className="contact-option"
        onClick={() => handleEmailClick("larc@ccmn.ufrj.br")}
        aria-label="Email LARC"
      >
        <EmailIcon />
        <span className="contact-text">LaRC</span>
      </button>

      <button
        className="contact-option"
        onClick={() => handleEmailClick("ccturci@gaim.com")}
        aria-label="Email Cassia"
      >
        <EmailIcon />
        <span className="contact-text">Coordenadora</span>
      </button>

      <button
        className="contact-option"
        onClick={() => handleLinkClick("https://www.instagram.com/larc.ufrj")}
        aria-label="Instagram LARC"
      >
        <InstagramIcon />
        <span className="contact-text">@larc.ufrj</span>
      </button>

      <button
        className="contact-option"
        onClick={() =>
          handleLinkClick(
            "https://www.youtube.com/@laboratorioderepresentacao8663"
          )
        }
        aria-label="YouTube LARC"
      >
        <YouTubeIcon />
        <span className="contact-text">YouTube</span>
      </button>

      {/* Notification Toast */}
      {notification && <div className="notification-toast">{notification}</div>}
    </div>
  );
};

export default ContactOptions;
